import technologies from "../data/technologies";
import Icon from "./Icon";
import SectionHeading from "./SectionHeading";

const pillars = [
  {
    icon: "mission",
    title: "Our Mission",
    description:
      "To deliver innovative and sustainable technology solutions that empower businesses and enrich lives.",
  },
  {
    icon: "vision",
    title: "Our Vision",
    description:
      "To be a global leader in digital transformation, creating a smarter, connected and more sustainable future.",
  },
];

function About() {
  return (
    <section className="section" id="about">
      <div className="container">
        <SectionHeading
          eyebrow="Who We Are"
          title="Our Mission & Vision"
          subtitle="A software house built on innovation, craftsmanship and a passion for solving real-world problems."
        />
        <div className="card-grid card-grid--2 reveal">
          {pillars.map((pillar) => (
            <article className="card-grid__item" key={pillar.icon}>
              <div className="pillar-card">
                <div className="pillar-card__icon">
                  <Icon name={pillar.icon} size={48} />
                </div>
                <h3 className="pillar-card__title">{pillar.title}</h3>
                <p className="pillar-card__desc">{pillar.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="about-tech">
          <SectionHeading
            eyebrow="Our Stack"
            title="Technologies We Work With"
          />
          <div className="tech-grid reveal">
            {technologies.map((tech) => (
              <div className="tech-chip" key={tech.name} title={tech.name}>
                <i className={`${tech.devicon} tech-chip__logo`} />
                <span className="tech-chip__name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
